import * as React from 'react';
import { Query } from 'react-apollo';
import { LensLineageCountsQuery, LensLineageCountsQueryVariables } from '../../../gen-src/queries/LensLineageCountsQuery';
import { LensLineageCountsQueryGql } from '../../queries/LensLineageCountsQueryGql';
import { LineageCountsParentProps } from '../lineage/LineageCountsCacher';
import { renderUnfilteredLineageCounts } from '../lineage/LineageCountsFunctions';

export type LensLineageCounts = Readonly<{
  upstreamDatabases: number;
  upstreamTables: number;
  upstreamVirtualConnections: number;
  upstreamVirtualConnectionTables: number;
  upstreamFlows: number;
  upstreamDatasources: number;
  fields: number;
}>;

function createUnfilteredCounts(data: LensLineageCountsQuery): LensLineageCounts | null {
  const lens = data?.lenses && data.lenses[0];
  if (lens
    && lens.upstreamDatabasesConnection
    && lens.upstreamTablesConnection
    && lens.upstreamVirtualConnectionsConnection
    && lens.upstreamVirtualConnectionTablesConnection
    && lens.upstreamFlowsConnection
    && lens.upstreamDatasourcesConnection
    && lens.fieldsConnection
  ) {
    return {
      upstreamDatabases: lens.upstreamDatabasesConnection.totalCount,
      upstreamTables: lens.upstreamTablesConnection.totalCount,
      upstreamVirtualConnections: lens.upstreamVirtualConnectionsConnection.totalCount,
      upstreamVirtualConnectionTables: lens.upstreamVirtualConnectionTablesConnection.totalCount,
      upstreamFlows: lens.upstreamFlowsConnection.totalCount,
      upstreamDatasources: lens.upstreamDatasourcesConnection.totalCount,
      fields: lens.fieldsConnection.totalCount,
    };
  }
  return null;
}

export type LensLineageCountsQueryWrapperProps = Readonly<{
  vizportalUrlId: string;
} & LineageCountsParentProps<LensLineageCounts>>;

export const LensLineageCountsQueryWrapper = (props: LensLineageCountsQueryWrapperProps) => {
  return <Query<LensLineageCountsQuery, LensLineageCountsQueryVariables>
    query={LensLineageCountsQueryGql}
    variables={{ vizportalUrlId: props.vizportalUrlId }}>
    {result => renderUnfilteredLineageCounts(result, createUnfilteredCounts, props.children)}
  </Query>
};

